import { h } from 'vue';
import util from '@/common/util';

export default {
    name: 'site-wrap-item',
    emits: ['updateStatus'],
    inject: ['wrapItems'],
    props: ['dataItem'],
    data: function() {
        return {
            id: util.uuidv4()
        }
    },
    render() {
        var slot = this.$slots.default ? this.$slots.default() : [];
        var wrapItem = this.wrapItems[this.id];
        return h('div', {  
            class: `site-wrap-item`, 
            style: wrapItem?.hidden ? 'display:none;' : ''
        }, slot);
    },
    mounted() {
        var wrapItem = this.wrapItems[this.id];
        if (!wrapItem?.hidden) {
            this.$nextTick(() => {
                this.$emit('updateStatus', {
                    id: this.id,
                    width: this.$el.clientWidth,
                    dataItem: this.dataItem
                });
            });
        }
    }
};
